// Bevestigingsvenster. De markup staat in body.html (#confirmModal).

export function showConfirm(title,msg,cb) {
  document.getElementById('confirmTitle').textContent=title;
  document.getElementById('confirmMessage').textContent=msg;
  document.getElementById('confirmBtn').onclick=()=>{cb();closeConfirm();};
  document.getElementById('confirmModal').classList.add('open');
}
export function closeConfirm() { document.getElementById('confirmModal').classList.remove('open'); }
